module.exports = __webpack_public_path__ + "static/nav-background-dark-sq-mobile-3cb0459d341caf66a8d653c1687db6a0.png";